export const rootStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 0.5,
  marginTop: 0.5,
};

export const chipStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '2px 8px',
  borderRadius: '12px',
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.default',
  cursor: 'pointer',
  transition: 'background-color 120ms ease, border-color 120ms ease',
  '&:hover': {
    borderColor: 'primary.main',
    backgroundColor: 'action.hover',
  },
};

export const chipOwnStyles = {
  ...chipStyles,
  borderColor: 'primary.main',
  backgroundColor: 'primary.light',
  color: 'primary.main',
};

export const chipLabelStyles = {
  lineHeight: 1,
  color: 'inherit',
};
